import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import type { SlotContents } from '@amplience/content-types/typings/s-srp-layout';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate';
import { renderAmplienceSlotComponents } from '@storefront/lib-global/utils/amplienceUtils';
import { SRPAmplienceComponents } from '../srpAmplienceComponents';
import { AdjustSearchText, CategoryHeading, NoResultsContainer, NoResultsFoundText } from './NoSearchResults.styles';

const AmplienceComponents = {
  ...SRPAmplienceComponents,
};

type NoSearchResultsProps = {
  slotContent: SlotContents | null;
  handlebarComponents: HandlebarTemplateProps[] | null;
};

export function NoSearchResults({ slotContent, handlebarComponents }: NoSearchResultsProps) {
  const { t } = useTranslation(['lib-products-common']);
  const { locale } = useRouter();

  const noSearchResultsContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    noSearchResultsContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <NoResultsContainer ref={noSearchResultsContainerRef}>
      <NoResultsFoundText role="alert">{t('srp.no.results.found')}</NoResultsFoundText>
      <AdjustSearchText>{t('srp.adjust.search.text')}</AdjustSearchText>
      <CategoryHeading>{t('srp.shop.by.category')}</CategoryHeading>
      {!!slotContent &&
        renderAmplienceSlotComponents(slotContent.pageContent, AmplienceComponents, handlebarComponents, locale)}
    </NoResultsContainer>
  );
}
